import { tokensDemo } from './demos/TokensDemo';
import { bravoLogoDemo } from './demos/BravoLogoDemo';
import { buttonsDemo } from './demos/ButtonsDemo';
import { buttonRowDemo } from './demos/ButtonRowDemo';
import { badgesDemo } from './demos/BadgesDemo';
import { chipsDemo } from './demos/ChipsDemo';
import { factChipsDemo } from './demos/FactChipsDemo';
import { timelineDemo } from './demos/TimelineDemo';
import { checkListDemo } from './demos/CheckListDemo';
import { numberedListDemo } from './demos/NumberedListDemo';
import { segmentedToggleDemo } from './demos/SegmentedToggleDemo';
import { linksDemo } from './demos/LinksDemo';
import { cardsDemo } from './demos/CardsDemo';
import { messageCardDemo } from './demos/MessageCardDemo';
import { labeledValueBoxDemo } from './demos/LabeledValueBoxDemo';
import { metricTilesDemo } from './demos/MetricTilesDemo';
import { headedCardDemo } from './demos/HeadedCardDemo';
import { labeledValuesDemo } from './demos/LabeledValuesDemo';
import { reportLauncherDemo } from './demos/ReportLauncherDemo';
import { alertsDemo } from './demos/AlertsDemo';
import { loadersDemo } from './demos/LoadersDemo';
import { holidayLoadersDemo } from './demos/HolidayLoadersDemo';
import { paginationDemo } from './demos/PaginationDemo';
import { listPageDemo } from './demos/ListPageDemo';
import { searchStripDemo } from './demos/SearchStripDemo';
import { loadedDataTableDemo } from './demos/LoadedDataTableDemo';
import { tabbedPageDemo } from './demos/TabbedPageDemo';
import { pageShellDemo } from './demos/PageShellDemo';
import { stepSectionDemo } from './demos/StepSectionDemo';
import { standalonePageDemo } from './demos/StandalonePageDemo';
import { notificationDemo } from './demos/NotificationDemo';
import { toastDemo } from './demos/ToastDemo';
import { confirmDialogsDemo } from './demos/ConfirmDialogsDemo';
import { dialogWindowDemo } from './demos/DialogWindowDemo';
import { formSectionDemo } from './demos/FormSectionDemo';
import { wizardDemo } from './demos/WizardDemo';
import { wizardSideBySideDemo } from './demos/WizardSideBySideDemo';
import { inputsTextDemo } from './demos/InputsTextDemo';
import { inputsToggleDemo } from './demos/InputsToggleDemo';
import { checkboxListDemo } from './demos/CheckboxListDemo';
import { inlineSelectDemo } from './demos/InlineSelectDemo';
import { settingRowsDemo } from './demos/SettingRowsDemo';
import { inputsDateTimeDemo } from './demos/InputsDateTimeDemo';
import { inputsSelectDemo } from './demos/InputsSelectDemo';
import { inputsDataBoundDemo } from './demos/InputsDataBoundDemo';

// Central registry of design-system gallery demos. Adding a component to the
// gallery = one demo file in ./demos + one import + one array entry here.
// Descriptor shape: { id, title, category, importPath, notes, snippet, render }
export const demoRegistry = [
  tokensDemo,
  bravoLogoDemo,
  buttonsDemo,
  buttonRowDemo,
  badgesDemo,
  chipsDemo,
  factChipsDemo,
  timelineDemo,
  checkListDemo,
  numberedListDemo,
  segmentedToggleDemo,
  linksDemo,
  alertsDemo,
  loadersDemo,
  holidayLoadersDemo,
  cardsDemo,
  messageCardDemo,
  labeledValueBoxDemo,
  metricTilesDemo,
  headedCardDemo,
  labeledValuesDemo,
  reportLauncherDemo,
  listPageDemo,
  searchStripDemo,
  paginationDemo,
  loadedDataTableDemo,
  tabbedPageDemo,
  pageShellDemo,
  stepSectionDemo,
  standalonePageDemo,
  notificationDemo,
  toastDemo,
  confirmDialogsDemo,
  dialogWindowDemo,
  formSectionDemo,
  wizardDemo,
  wizardSideBySideDemo,
  inputsTextDemo,
  inputsToggleDemo,
  checkboxListDemo,
  inlineSelectDemo,
  settingRowsDemo,
  inputsDateTimeDemo,
  inputsSelectDemo,
  inputsDataBoundDemo,
];
